// extracted by mini-css-extract-plugin
export default {"employee_details":"EmployeeDetails_employee_details__jUBOZ","details_header":"EmployeeDetails_details_header__i9HoG","detailed_section":"EmployeeDetails_detailed_section__d3pDD"};